
let IslandBookManager = xClass("IslandBookManager")


let _instance = null;
IslandBookManager.getInstance = function () {
    if (_instance) {
        return _instance
    }
    _instance = new IslandBookManager();
    // instance.init()
    return _instance
}

IslandBookManager.FROM_BOOK = "FROM_BOOK"
IslandBookManager.FROM_ISLAND = "FROM_ISLAND"

/**
 * 启动
 * 支持抓取期间被多次调用
 * 每次返回同一个对象
 * @return Promise<config>
 */
IslandBookManager.Start = function () {
    if (_instance)
        return Promise.resolve();

    _instance = new IslandBookManager();
    return Promise.resolve();
}

IslandBookManager.prototype.ctor = function (config) {
    let self = this;

    self.config = config; // 配置
    self.init();
}

IslandBookManager.prototype.init = function () {
    let self = this;
}

IslandBookManager.prototype.createDCSession = function ()
{
    this.dcSession = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`
    return this.dcSession
}

IslandBookManager.prototype.getDCSession = function ()
{
    return this.dcSession
}


/**
 * 获取配置
 */
IslandBookManager.prototype.getConfig = function () {
    let self = this;
    return self.config;
}

IslandBookManager.prototype.showLevel = function(data, starView)
{
    let levelID = data && data.levelId || 1

    if (levelID >= UserManager.getInstance().getUserRef().getTopLevelId())
    {
        this._isPlayANewLevel = true
    }
    else
    {
        this._isPlayANewLevel = false
    }

    let homeScene = require("clover/scene/HomeScene").getInstance()
    starView.setVisible(false)

    homeScene.selectLevel(levelID, function () {
        // starView.runAction(cc.Sequence.create(
        //     cc.FadeOut.create(0.3),
        //     cc.CallFunc.create(() => {
        //         starView.setVisible(false)
        //     })
        // ))
        // starView.onClose()
        if (homeScene.btnLayer.islandBookBtn){
            homeScene.btnLayer.islandBookBtn.isBusy = false;
        }
    }, function () {
        if (!starView.isClosed) {
            starView.runAction(cc.Sequence.create(
                cc.FadeIn.create(0.3),
                cc.CallFunc.create(() => {
                    starView.setVisible(true)
                })
            ))
        }
    })
}


IslandBookManager.prototype.openStarPanelFromScene = function(data)
{
    this._starPanelData = data
    this._starPanelFrom = IslandBookManager.FROM_ISLAND
    require.ensure([], () => {
        let logic = require("./IslandBookLogic")
        logic.openStarPanel(data, () => {
            this.onStarPanelClosed()
        })
    }, null, 'act')

}

IslandBookManager.prototype.openStarPanelFromBook = function(data)
{
    if (data)
    {
        this._starPanelData = data
    }
    this._starPanelFrom = IslandBookManager.FROM_BOOK
    require.ensure([], () => {
        let logic = require("./IslandBookLogic")
        logic.openStarPanel(this._starPanelData, () => {
            this.onStarPanelClosed()
        })
    }, null, 'act')

}

IslandBookManager.prototype.onStarPanelClosed = function()
{
    console.log("this._starPanelFrom", this._starPanelFrom)
    if (this._starPanelFrom == IslandBookManager.FROM_BOOK)
    {
        require.ensure([], () => {
            let logic = require("./IslandBookLogic")
            logic.openIslandBook(null, ()=>{}, ()=>{
                // 到最高关后出关卡关闭刷星的界面处理宝船的动画
                let scene = cc.director.getRunningScene();
                if (scene.name == "HomeScene"){
                    scene.checkGoldTurnShipAnim();
                }
            })
        }, null, 'act')

    }
    //this._starPanelFrom = null
}
// 打开补星列表面板
IslandBookManager.prototype.openIslandBook = function(closeCb)
{
    require.ensure([], () => {
        let logic = require("./IslandBookLogic")
        logic.openIslandBook(
            ()=> {},
            ()=> {},
            ()=> {
                closeCb && closeCb()
            },
            this._starPanelMsg
        ); 
    }, null, 'act')
 
}
//记录打开的补星界面中的星星面板信息
IslandBookManager.prototype.recordStarPanelMsg = function(data)
{
    this._starPanelMsg = data;
}


// 获得一个岛的拥有星数
IslandBookManager.prototype.getStarOfIsland = function (islandId)
{
    var topLevel = UserManager.getInstance().getUserRef().getTopLevelId()
    let island = UserManager.getInstance().getIslandConfigById(islandId)
    let star = 0
    if (!island)
    {
        return star
    }

    var minLevel = island.minLevel + 1
    var maxLevel = island.maxLevel

    if (topLevel < minLevel)
    {
        return star
    }

    if (topLevel < maxLevel)
    {
        maxLevel = topLevel
    }

    for (var i = minLevel; i <= maxLevel; i++)
    {
        var gotStar = UserScore.getInstance().getScore(i).star
        star += gotStar
    }
    return star
}
// 获取除了满星以外的岛屿关卡
IslandBookManager.prototype.getExceptFullOfIsland = function(islandId){
    let returnValue = []
    let island = UserManager.getInstance().getIslandConfigById(islandId)
    var topLevel = MetaManager.getInstance().getMaxNormalLevelByLevelArea()
    var minLevel = island.minLevel + 1
    var maxLevel = island.maxLevel < topLevel ? island.maxLevel : topLevel
    if (minLevel < 1)
    {
        minLevel = 1
    }

    for (var j = minLevel; j <= maxLevel; j++)
    {
        let digest = LevelConfigManager.getInstance().getLevelDigest(j)
        let score = UserScore.getInstance().getScore(j)
        let starMax = $len((digest && digest.scoreTargets || table()))
        if (score.star >= starMax)
        {
            continue
        }
        returnValue.push(
            {
                star: score.star,
                starMax:starMax,
                gameMode: digest.gameMode,
                levelId: j,
                isHardLevel: digest.isHardLevel
            }
        )
    }
    return returnValue
}

IslandBookManager.prototype.getUnfullLevelOfIsland = function(islandId)
{
    let returnValue = []
    let island = UserManager.getInstance().getIslandConfigById(islandId)
    var topLevel = MetaManager.getInstance().getMaxNormalLevelByLevelArea()
    var userTopLevel = UserManager.getInstance().getUserRef().getTopLevelId()
    var minLevel = island.minLevel + 1
    var maxLevel = island.maxLevel < topLevel ? island.maxLevel : topLevel;
    var maxLevel = maxLevel > userTopLevel - 1 ? userTopLevel - 1 : maxLevel;

    for (var j = minLevel; j <= maxLevel; j++)
    {
        let digest = LevelConfigManager.getInstance().getLevelDigest(j)
        let score = UserScore.getInstance().getScore(j)
        let starMax = $len((digest && digest.scoreTargets || table()))
        if (score.star >= starMax)
        {
            continue
        }
        returnValue.push(
            {
                star: score.star,
                starMax:starMax,
                gameMode: digest.gameMode,
                levelId: j,
                isHardLevel: digest.isHardLevel
            }
        )
    }
    return returnValue
}


IslandBookManager.prototype.getAllLevelOfIsland = function(islandId)
{
    let returnValue = []
    let island = UserManager.getInstance().getIslandConfigById(islandId)
    var topLevel = MetaManager.getInstance().getMaxNormalLevelByLevelArea()
    var minLevel = island.minLevel + 1
    var maxLevel = island.maxLevel < topLevel ? island.maxLevel : topLevel
    if (minLevel < 1)
    {
        minLevel = 1
    }

    for (var j = minLevel; j <= maxLevel; j++)
    {
        let digest = LevelConfigManager.getInstance().getLevelDigest(j)
        let score = UserScore.getInstance().getScore(j)
        let starMax = $len((digest && digest.scoreTargets || table()))
        returnValue.push(
            {
                star: score.star,
                starMax:starMax,
                gameMode: digest.gameMode,
                levelId: j,
                isHardLevel: digest.isHardLevel
            }
        )
    }
    return returnValue
}

//获得一个岛的最大星数

IslandBookManager.prototype.getMaxStarOfIsland = function (islandId)
{
    let island = UserManager.getInstance().getIslandConfigById(islandId)
    let star = 0
    if (!island)
    {
        return star
    }
    var topLevel = MetaManager.getInstance().getMaxNormalLevelByLevelArea()
    // var maxLevel = island.maxLevel < topLevel ? island.maxLevel : topLevel
    var maxLevel = island.maxLevel//现在改成获取全部而且不是只算当前开放关卡
    var minLevel = island.minLevel + 1

    for (var j = minLevel; j <= maxLevel; j++)
    {
        let digest = LevelConfigManager.getInstance().getLevelDigest(j)
        let starMax = $len((digest && digest.scoreTargets || table()))
        star += starMax
    }
    return star
}

// 获得所有关卡最大星数
IslandBookManager.prototype.getTotalMaxStar = function ()
{
    let islandConfigs = UserManager.getInstance().getIslandsConfig();
    let star = 0
    for (var i = 0; i < islandConfigs.length; i++)
    {
        var island = islandConfigs[i]
        if (!island)
        {
            continue
        }

        var minLevel = island.minLevel + 1
        var topLevel = MetaManager.getInstance().getMaxNormalLevelByLevelArea()
        var maxLevel = island.maxLevel < topLevel ? island.maxLevel : topLevel

        for (var j = minLevel; j <= maxLevel; j++)
        {
            let digest = LevelConfigManager.getInstance().getLevelDigest(j)
            let starMax = $len((digest && digest.scoreTargets || table()))
            star += starMax
        }
    
    }

    return star
}

// 获得当前的总星数
IslandBookManager.prototype.getTotalStar = function ()
{
    var topLevel = UserManager.getInstance().getUserRef().getTopLevelId()
    var star = 0
    for (var i = 1; i <= topLevel; i++)
    {
        var gotStar = UserScore.getInstance().getScore(i).star
        star += gotStar
    }
    return star
}

//岛屿配置列表
IslandBookManager.prototype.getAvailableIslandConfigs = function (show_type)
{
    let showType = show_type ? show_type : "all";
    let arr = []
    let islandConfigs = UserManager.getInstance().getIslandsConfig();
    var topLevel = MetaManager.getInstance().getMaxNormalLevelByLevelArea()

    let handleData = (data)=>{
        if (!this.islandRewards) return data;
        for (let i = 0; i < this.islandRewards.length; i++) {
            let conf = this.islandRewards[i];
            if (conf && data.id == conf.islandId){
                data.rewardItems = conf.rewards;
                data.status = conf.status;
            }
        }
        return data;
    }

    for (var i = 0; i < islandConfigs.length; i++)
    {
        var island = islandConfigs[i]
        if (!island || island.unlock > 1)
        {
            continue
        }

        if (topLevel < island.minLevel + 1)
        {
            continue
        }
        island = handleData(island)
        if (showType != "all" && island.status == true){
            continue
        }

        arr.push(island)
    }
    arr.sort((a,b)=>{
        return b.id - a.id;
    });
    cc.log("[IslandBook]", "IslandBookManager getAvailableIslandConfigs this.islandRewards",this.islandRewards);
    cc.log("[IslandBook]", "IslandBookManager getAvailableIslandConfigs arr",arr);


    return arr
}

//满星岛屿的数量
IslandBookManager.prototype.getFullIslandNum = function ()
{
    let islandConfigs = UserManager.getInstance().getIslandsConfig();
    let count = 0
    for (var i = 0; i < islandConfigs.length; i++)
    {
        var island = islandConfigs[i]
        if (!island)
        {
            continue
        }
        else if (this.isIslandStarFull(island.id, true))
        {
            count ++
        }
    }
    return count
}

//按索引从小到大，第一个未满星的岛
/**
 * 
 * @returns 岛屿id， 是否当前关卡全满星
 */
IslandBookManager.prototype.firstUnFullIsland = function ()
{
    let islandConfigs = UserManager.getInstance().getIslandsConfig();
    for (var i = 0; i < islandConfigs.length; i++)
    {
        var island = islandConfigs[i]
        if (!island || island.unlock > 1 || island.minLevel > UserManager.getInstance().getMaxLevelServer())
        {
            continue
        }
        else if (!this.isIslandStarFull(island.id))
        {
           return [island.id, false]
        }
    }
    return [1, true]
}

//是否打关之前就是满星
IslandBookManager.prototype.fullStarBeforePass = function ()
{
    return this.fullStarStatus
}

//是否完成了满星
IslandBookManager.prototype.fullStarDone = function ()
{
    if (this.fullStarStatus)
    {
        return false
    }

    if (!this.playingislandId)
    {
        false
    }

    if (this.isIslandStarFull(this.playingislandId))
    {
        return true
    }

    return false
}   

//记录当前是否满星
IslandBookManager.prototype.recordFullStar = function (levelId)
{
    let islandConfigs = UserManager.getInstance().getIslandsConfig();
    let islandId = 1
    for (var i = 0; i < islandConfigs.length; i++)
    {
        var island = islandConfigs[i]
        if (!island)
        {
            continue
        }
        var minLevel = island.minLevel + 1
        var topLevel = MetaManager.getInstance().getMaxNormalLevelByLevelArea()
        var maxLevel = island.maxLevel < topLevel ? island.maxLevel : topLevel
        if (minLevel <= levelId && maxLevel >= levelId)
        {
            islandId = islandConfigs[i].id
            break
        }
    }

    this.playingislandId = islandId
    this.playingLevelId = levelId
    this.fullStarStatus =  this.isIslandStarFull(islandId)
}

IslandBookManager.prototype.isIslandLock = function (id){
    // 这里处理特殊情况 目前第一次服务端返回的是0 暂时服务端没找到具体原因 这里先行简单处理 只处理新用户的 因为重新登录的用户不会有这个问题
    if (_G.kIsNewUser && UserManager.getInstance().getIslandsInfo().topId == 0 && id == 1){
        return false;
    }
    if (UserManager.getInstance().getIslandsInfo().topId < id) { //未解锁
        return true
    }
    return false
}
//单个岛屿是否满星 isCalculateNotOpen是否计算未开放岛屿 
IslandBookManager.prototype.isIslandStarFull = function (islandId,isCalculateNotOpen)
{
    if (UserManager.getInstance().getIslandsInfo().topId < islandId)
    {
        return false;
    }
    let island = UserManager.getInstance().getIslandConfigById(islandId)

    var minLevel = island.minLevel + 1
    var topLevel = UserManager.getInstance().getUserRef().getTopLevelId()
    var allmaxLevel = MetaManager.getInstance().getMaxNormalLevelByLevelArea()
    var maxLevel = island.maxLevel < allmaxLevel ? island.maxLevel : allmaxLevel
    if (isCalculateNotOpen){
        maxLevel = island.maxLevel;
    }

    if (topLevel < maxLevel)
    {
        return false;
    }
    // if (minLevel < 1)
    // {
    //     minLevel = 1;
    // }
    
    let isFull = true
    for (var i = minLevel; i <= maxLevel; i++)
    {
        var gotStar = UserScore.getInstance().getScore(i).star
        let digest = LevelConfigManager.getInstance().getLevelDigest(i)
        let starMax = $len((digest && digest.scoreTargets || table()))
        if (gotStar < starMax)
        {
            isFull = false
            break
        }
    }

    return isFull
}

/**
 * 获取当前打点click_type
 */
IslandBookManager.prototype.getDCClickType = function()
{
    return this._starPanelFrom == IslandBookManager.FROM_BOOK ? "main" : "map";
}

IslandBookManager.prototype.getIslandNewIntroRes = function () {
    let res = [];
    this.listData = this.getAvailableIslandConfigs()
    for (let i = 0; i < this.listData.length; i++) {
        if (UserManager.getInstance().isLevelTestGroup()){
            res.push(`island/${this.listData[i].id}_new_intro_B.png`);
        }else{
            res.push(`island/${this.listData[i].id}_new_intro.png`);
        }
    }
    // cc.log("getIslandNewIntroRes ",res)
    return res;
}
// 获取满星奖励
IslandBookManager.prototype.getFullStarRewards = function () {
    // let onSuccessCb = (evt) => {
    //     cc.log("[IslandBook]", "IslandBookManager getFullStarRewards onSuccessCb evt",evt);
    //     onSuccess(evt);
    // }
    // let onFailCb = (evt) => {
    //     cc.log("[IslandBook]", "IslandBookManager getFullStarRewards onFailCb");
    //     onFail();
    // }
    // var http = IslandGetFullStarRewardsHttp.new();
    // http.addEventListener(Events.kComplete, onSuccessCb);
    // http.addEventListener(Events.kError, onFailCb);
    // http.addEventListener(Events.kCancel, onFailCb);
    // http.load();
    return new Promise((resolve, reject)=> {
        let onSuccess = (evt) => {
            cc.log("[IslandBook]", "IslandBookManager getFullStarRewards onSuccessCb evt",evt);
            // onSuccess(evt);
            this.islandRewards = evt.data.islandRewards;

            resolve(evt);
        }
        let http = IslandGetFullStarRewardsHttp.new();
        http.addEventListener(Events.kComplete, onSuccess);
        http.addEventListener(Events.kError, reject);
        http.addEventListener(Events.kCancel, reject);
        http.load();
    })
}
// 领取满星奖励
IslandBookManager.prototype.fetchFullStarRewards = function (id, onSuccess, onFail) {
    let onSuccessCb = (evt) => {
        cc.log("[IslandBook]", "IslandBookManager fetchFullStarRewards onSuccessCb evt",evt);
        onSuccess(evt);
    }
    let onFailCb = (evt) => {
        cc.log("[IslandBook]", "IslandBookManager fetchFullStarRewards onFailCb evt",evt);
        let errcode = evt ? evt.data : "未知错误";
        Toast.make(getText(`error.tip.${errcode}`));

        onFail();
    }
    var http = IslandFetchFullStarRewardsHttp.new();
    http.addEventListener(Events.kComplete, onSuccessCb);
    http.addEventListener(Events.kError, onFailCb);
    http.addEventListener(Events.kCancel, onFailCb);
    http.load(id);
}
// 是否有可能领取的满星奖励
IslandBookManager.prototype.isHaveCanReceiveReward = function () {
    if(!this.islandRewards || this.islandRewards.length <= 0) return false;
    for (let i = 0; i < this.islandRewards.length; i++) {
        let conf = this.islandRewards[i];
        if (conf && !conf.status && this.isIslandStarFull(conf.islandId, true)) return true;
        
    }
    return false;
}


module.exports = IslandBookManager